export default function getEnv(name) {
    const env = envConfig?.[name] || process.env[name];

    if(!env || env === '') {
        return null;
    }

    return env;
}